import React, { useState, useEffect, useRef } from 'react';
import { Row, Col } from 'reactstrap';
import fpass from '../../../../images/firstpasslogo.svg';
import clientLogo from '../../../../images/mhlogo-light.svg';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { interval } from 'rxjs';
import { getAudioFiles } from '../../../../helpers/helpersIndex';
import { Howl } from 'howler';

let subscribe;

const ThemeOneTopbar: React.FC = () => {
    const audio = new Audio();
    const audioPath = `assets/audio/${getAudioFiles('theme1')}`;
    const { t } = useTranslation("translations");
    const loginTime = `${moment().format('DD-MM-YYYY')} ${moment().format('LT')}`;
    const difference = 60 - new Date().getSeconds();
    const [time, setTime] = useState(loginTime);
    const soundRef = useRef<any>();
    audio.src = audioPath;
    let sound: Howl = new Howl({
        src: [audioPath]
    });
    audio.load();

    const replayAudio = () => {
        sound.currentTime = 0;
        sound.pause();
        sound.play();
    }

    const playAudio = () => {
        console.log("playAudio => ", soundRef, soundRef.current);
        if (soundRef.current)
            soundRef.current.play();
        // try {
        //     audio.currentTime = 0;
        //     audio.pause();
        //     const playPromise = audio.play();
        //     if (playPromise !== null && playPromise) {
        //         playPromise.catch(e => {
        //             console.log('error=>1', e);
        //             replayAudio();
        //         })
        //     }
        //     else
        //         replayAudio();
        // }
        // catch (e) {
        //     console.log('error=>', e);
        //     replayAudio();
        // }
    }

    useEffect(() => {
        subscribe = interval(1000 * difference).subscribe(() => {
            setTime(`${moment().format('DD-MM-YYYY')} ${moment().format('LT')}`);
        })
        return () => {
            if (subscribe)
                subscribe.unsubscribe();
        }
    })

    return (
        <>
            <Row className="mdbHeader">
                <Col className="mlogos">
                    <img src={clientLogo} alt="" className="clientLogo" />
                </Col>
                <Col className="rightlogo">{time}</Col>
            </Row>
            {/* <audio ref={soundRef}>
                    <source type="audio/wav" src={audioPath} />
                </audio> */}
            {/* <Col className="text-center">{time} <span onClick={playAudio}>.</span></Col> */}
        </>
    )
}
export default React.memo(ThemeOneTopbar);